import React from "react";

function PolicyholdersPrivacy() {
  return (
    <div className="py-6">
      {/* <h1 className="font-bold text-6xl mb-20">Privacy Policy for Policyholders</h1> */}
      <p className="mb-20">Effective Date: March 18, 2025</p>

      <p className="mb-20">
        We are committed to protecting your privacy and the security of your
        personal and health information. This Privacy Policy explains how we
        collect, use, disclose, and safeguard your data when you use our mobile
        application and related services (collectively, the “Services”). By
        accessing or using our Services, you consent to the practices described
        in this Privacy Policy. We reserve the right to update this Privacy
        Policy as needed to comply with evolving legal standards and security
        protocols.
      </p>

      <h2 className="font-bold text-xl mb-2">1. Information We Collect</h2>
      <p className="mb-20">
        We collect various types of information to deliver and improve our
        Services. This includes:
      </p>
      <ul className="list-disc ml-6 mb-20">
        <li>
          Personal Information: Information (email address) that may identify
          you.
        </li>
        <li>
          Demographic Data: Age, gender, weight, height, profession, underlying
          conditions, etc.
        </li>
        <li>
          Health Information: Data from your wearable device such as heart rate,
          activity levels, sleep patterns, caloric intake, and other
          physiological metrics.
        </li>
        <li>
          Non-Personal Information: Aggregated data, log data, and usage
          patterns.
        </li>
      </ul>

      <h2 className="font-bold text-xl mb-2">2. Use of Information</h2>
      <p className="mb-20">
        With your consent, we use the information we collect for purposes
        including, but not limited to:
      </p>
      <ul className="list-disc ml-6 mb-20">
        <li>Providing, personalizing, and improving our Services.</li>
        <li>
          Generating real-time, AI-driven health insights, and personalized
          wellness recommendations. These insights are for informational
          purposes only and do not constitute medical advice.
        </li>
        <li>
          Developing analytics for insurance risk assessment and product
          development.
        </li>
        <li>
          Communicating with you regarding updates, support, and important
          notifications.
        </li>
        <li>
          Detecting and preventing fraudulent or unauthorized activities and
          complying with legal obligations.
        </li>
      </ul>

      <h2 className="font-bold text-xl mb-2">3. Data Sharing and Disclosure</h2>
      <p className="mb-20">
        The analytics generated through your data may be shared with your insurance company for risk assessment, product development, and
        improving insurance-related analytics. We do not share your personally
        identifiable information with third parties except in the following
        circumstances:
      </p>
      <ul className="list-disc ml-6 mb-20">
        <li>
          With your explicit consent, when you authorize additional sharing.
        </li>
        <li>
          With trusted third-party service providers who help operate our
          Services (these providers are contractually required to protect your
          data).
        </li>
        <li>
          As required by law, regulation, or legal process (such as subpoenas or
          court orders).
        </li>
        <li>
          To protect our rights, property, or safety, and that of our users and
          others.
        </li>
      </ul>

      <h2 className="font-bold text-xl mb-2">4. Data Security</h2>
      <p className="mb-20">
        We take extensive measures to protect your information from unauthorized
        access, disclosure, alteration, or destruction.
      </p>
      {/* <ul className="list-disc ml-6 mb-20">
        <li>Encryption of data.</li>
        <li>Regular security and vulnerability assessments.</li>
      </ul> */}
      <p className="mb-20">
        While no system can guarantee absolute security, we continuously monitor
        and update our security practices to mitigate risk.
      </p>

      <h2 className="font-bold text-xl mb-2">5. Data Retention</h2>
      <p className="mb-20">
        We retain your personal and health information only for as long as
        necessary to fulfill the purposes for which it was collected or as
        required by law. Once your data is no longer needed, we will securely
        delete or anonymize it.
      </p>

      <h2 className="font-bold text-xl mb-2">6. Your Rights and Choices</h2>
      <ul className="list-disc ml-6 mb-20">
        <li>Opt-Out: You may opt out of using our Services at any time.</li>
        <li>
          Access and Correction: You have the right to access and update your
          personal information through the app or by contacting us.
        </li>
        <li>
          Deletion: You may request the deletion of your personal information,
          subject to applicable legal requirements.
        </li>
      </ul>

      <h2 className="font-bold text-xl mb-2">7. Children’s Privacy</h2>
      <p className="mb-20">
        Our Services are not intended for individuals under the age of 18. We do
        not knowingly collect personal information from children under 18. If we
        learn that we have inadvertently collected such information, we will
        promptly delete it.
      </p>

      <h2 className="font-bold text-xl mb-2">
        8. Updates to This Privacy Policy
      </h2>
      <p className="mb-20">
        We may update this Privacy Policy from time to time to reflect changes
        in our practices or legal requirements. Your
        continued use of our Services after such updates constitutes your
        acceptance of the revised Privacy Policy.
      </p>

      <h2 className="font-bold text-xl mb-2">9. Contact Us</h2>
      <p className="mb-20">
        If you have any questions, concerns, or requests regarding this Privacy
        Policy or our data practices, please contact us at:
        contact@mybeatshealth.com
      </p>

      <h2 className="font-bold text-xl mb-2">Conclusion</h2>
      <p className="mb-20">
        We value your privacy and are committed to safeguarding your personal
        and health information in accordance with this Privacy Policy and
        applicable laws. By using our Services, you acknowledge that you have
        read and understood this Privacy Policy and consent to our data
        practices.
      </p>
    </div>
  );
}

export default PolicyholdersPrivacy;
